/**
 * 条形图数据需要进行反转
 * @param data
 */
export function transformBarData(data) {
  return data ? data.slice().reverse() : data;
}